<template>
  <d-container fluid class="main-content-container p-4">
    <d-modal v-if="modalVisible" size="lg" @close="onModalClose">
      <d-modal-header>
        <d-modal-title>Détails du compte</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <div class="text-center mb-3">
          <d-link :to="transaction_link" target="_blank">
            Voir la transaction <i class="fa fa-external-link-alt"></i>
          </d-link>
        </div>
        <d-form-row>
          <d-col class="pr-3 border-right">
            <c-input container-class="mb-3" label="Titre" :value="title" disabled/>
            <c-input type="textarea" container-class="mb-3" label="Message" :value="message" disabled/>
          </d-col>
          <d-col class="ml-2">
            <c-input type="datetime" container-class="mb-3" label="Résolu le" :value="solved_at" disabled/>
            <c-input type="textarea" container-class="mb-3" label="Commentaire"
                     placeholder="Entrez un commentaire..." v-model="comment" :disabled="!is_editable"/>
            <d-form-checkbox v-model="solved" :disabled="!is_editable">
              Incident résolu
            </d-form-checkbox>
          </d-col>
        </d-form-row>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner v-if="is_editable" variant="success" :fetching="fetchingFormSubmit" @click="onFormSubmit">
          <template slot="icon">
            <i class="fa fa-save"></i>
          </template>
          Enregistrer
        </c-button-spinner>
        <b-button variant="secondary" @click="onModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-card class="card-small">
      <d-card-body class="pt-5">
        <c-table :fetching="fetchingData" :table-data="filteredData" :fields="fields" :actions="actions" :per-page="25">
          <p class="text-center" slot="empty">Aucun incident survenu.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import {Api, Toast} from "@/helpers"

export default {
  title: "Incidents",
  data() {
    return {
      statusFilter: '',
      search: '',
      fetchingSearch: false,

      fetchingData: false,
      data: [],

      //table header
      fields: [
        {key: 'title', label: 'Titre', sortable: true},
        {key: 'transaction.transaction_ref', label: 'Transaction assoc.', sortable: true},
        {key: 'solved_at_pretty', label: 'Résolu le', sortable: true},
        {key: 'status', label: 'Statut', sortable: true},
        {key: 'actions', label: 'Actions'},
      ],

      actions: [
        {type: 'white', icon: 'fa fa-ellipsis-h', title: "Détails du compte", handler: this.onItemSelect}
      ],

      modalVisible: false,

      selectedItem: null,

      comment: '',
      solved: false,

      submitted: false,
      fetchingFormSubmit: false,
    }
  },
  computed: {
    filteredData() {
      return this.data
      // const search = this.search.toLowerCase()
      // return this.data.filter(item => {
      //   return true
      // })
    },
    itemSelected() {
      return !!this.selectedItem
    },
    is_editable() {
      return this.auth.isOpManager() || this.auth.isHelpDesk()
    },
    transaction_link() {
      return this.itemSelected ? {
        name: 'transactions',
        query: {transaction_ref: this.selectedItem.transaction.transaction_ref}
      } : ''
    },
    title() {
      return this.itemSelected ? this.selectedItem.title : ''
    },
    message() {
      return this.itemSelected ? this.selectedItem.message : ''
    },
    solved_at() {
      return this.itemSelected ? this.selectedItem.solved_at : ''
    },
  },
  created() {
    this.fetchingData = true
    Api.get('/issue/list')
      .then(res => this.data = res.data.issues.map(this.mapItem))
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },
  methods: {
    mapItem(item) {
      return {
        ...item,
        status: item.solved_at ? "Résolu" : "Non résolu",
        statusVariant: item.solved_at ? "secondary" : "danger",
        solved_at_pretty: item.solved_at ? item.solved_at.replace(' ', '\n') : '---',
      }
    },
    onItemSelect(item) {
      this.selectedItem = item
      this.comment = item.comment
      this.solved = !!item.solved_at
      this.modalVisible = true
    },
    clearFields() {
      this.comment = ''
      this.solved = false
    },
    onModalClose() {
      this.modalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.clearFields()
    },
    isFormValid() {
      return true
    },
    onFormSubmit() {
      this.submitted = true

      if (!this.isFormValid()) return

      this.fetchingFormSubmit = true
      Api.postFormData('/issue/solve', {
        issue_id: this.selectedItem.id,
        solved: this.solved,
        comment: this.comment,
      })
        .then(res => {
          const issue = this.mapItem(res.data.issue)
          this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, issue)

          this.onModalClose()

          Toast.success(`L'incident "${issue.title}" a été mis à jour avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },
    onSearchSubmit() {
      this.fetchingSearch = true
      Api.postFormData('/user/find', {search: this.search})
        .then(res => this.data = res.data.users.map(this.mapItem))
        .catch(err => this.error = err)
        .then(() => this.fetchingSearch = false)
    },
  }
}
</script>

<style scoped>

</style>
